// extracted by mini-css-extract-plugin
export default {"menuItem":"_Gz6aOCy","menuItemActive":"Qf9OD_RU","linkLeftSide":"djoZ_3LM","childrenMenuList":"DPzedT1R"};